import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { Mode, Extension } from '@confluence/macro-tracker/entry-points/types.ts';
import type { InvalidExtensionProps } from './invalidExtensionTypes.ts';

export const InvalidExtensionLoader: LoadableType<
	Omit<
		InvalidExtensionProps & {
			mode: Mode;
			extensionKey?: string;
			attributes?: ExperienceAttributes;
			contentId: string;
		} & {
			node: Extension;
		},
		'editorActions'
	>
> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InvalidExtension" */ './InvalidExtension.tsx'))
			.InvalidExtension,
});
